import axios from "axios";

export const getZonesToCover = async (lang ,id) => {
  try {
    const brear = localStorage.getItem("token");
   
    const { data } = await axios.get(`/v1/admin/stores/${id}/delivery/zone-to-cover`, {

      
      headers: {
        Authorization: "Bearer " + `${brear}`,
             
        "Accept-Language": lang,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};